module.exports = __webpack_public_path__ + "img/slider.ea2e94a8.png";